import {
  PROMPTING_U_SKUS,
  SOC_SKUS,
  STREAM_VA_SKUS,
  UNLIMITED_100_STRIPE_ID,
  UNLIMITED_250_STRIPE_ID,
} from 'src/marketing/plans/constants'
import { enabledPlans } from 'src/marketing/plans/plansInfo'
import { SubscriptionType } from 'src/user/fragments'
import { Label } from 'src/__generated__/globalTypes'
import { useAccount } from '.'

const useSubscriptions = () => {
  const {
    stripeSubscription: currentSubscription,
    subscriptions: allSubscriptions,
    plan: currentPlan,
    labels,
  } = useAccount()

  const currenPlanStripeId = currentPlan.stripeId
  const newPlanStripeId = currentSubscription?.metadata?.planOnCancel
  const newPlan = enabledPlans.find(plan => plan.stripeId === newPlanStripeId)
  const isInGreenerStillGracePeriod = Boolean(
    labels.find(label => label === Label.GSA_SUBSCRIPTION_PAYMENT_FAILURE),
  )

  const hasPromptingUSubscription =
    allSubscriptions &&
    allSubscriptions.find((sub: SubscriptionType) =>
      PROMPTING_U_SKUS.includes(sub.sku),
    )

  const isStreamMarketingLabel = (label: Label): boolean =>
    label === Label.NOWSITE_ACTIVE || label === Label.NOWSITE_NEED_SETUP

  const hasStreamMarketingSubscription =
    labels.find(label => isStreamMarketingLabel(label)) !== undefined

  const hasStreamVASubscription =
    allSubscriptions &&
    allSubscriptions.find((sub: SubscriptionType) =>
      STREAM_VA_SKUS.includes(sub.sku),
    )

  const hasSocSubscription =
    allSubscriptions &&
    allSubscriptions.find((sub: SubscriptionType) => SOC_SKUS.includes(sub.sku))

  const isAutoReloadAvailable = ![
    UNLIMITED_100_STRIPE_ID,
    UNLIMITED_250_STRIPE_ID,
  ].includes(currenPlanStripeId)

  return {
    allSubscriptions,
    currentSubscription,
    currentPlan,
    currenPlanStripeId,
    newPlan,
    newPlanStripeId,
    isInGreenerStillGracePeriod,
    hasPromptingUSubscription,
    hasStreamMarketingSubscription,
    hasStreamVASubscription,
    hasSocSubscription,
    isAutoReloadAvailable,
  }
}

export default useSubscriptions
